import styled from 'styled-components';

export const Wrapper = styled.aside`
    h2 {
        background: #e65100;
        color: #fff;
        font-weight: 400;
        font-size: 1.15rem;
        padding: 0.6rem 0 0.5rem 2.5rem;
        margin: 0;
        border-radius: 3px 0 0 0;
        i {
            position: absolute;
            left: 15px;
            top: 10px;
        }
    }
    position: absolute;
    right: 5px;
    top: 71px;
    width: 500px;
    height: 66s0px;
    z-index: 12;
    background: #fff;
    box-shadow: 0 2px 6px 2px #ddd;
`;

export const About = styled.div`
    .user-info-panel {
        padding: 15px;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        .burger {
            width: 40%;
        }

        .release-notes-container {
            width: 100%;
        }

        .bottom-wrapper {
            flex: 0 0 50%;
            align-items: flex-end;
            display: flex;
            margin-top: 30px;
            .logout {
                padding: 0.5rem 1rem;
                background: #12427d;
                border-radius: 4px;
                border: 0;
                color: #fff;
                font-size: 0.9rem;
                outline: none;
                cursor: pointer;
            }
        }
    }
`;

export const ClearCacheWrapper = styled.div`
    padding: 1rem;
    .action-section {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0.4rem;
        &:not(:last-child) {
            margin-bottom: 1.25rem;
        }
        button {
            padding: 0.5rem 1rem;
            background: #12427d;
            border-radius: 4px;
            border: 0;
            color: #fff;
            font-size: 0.9rem;
            cursor: pointer;
        }
        span {
            font-size: 0.75rem;
            color: #555;
        }
    }
`;
